import { isArray } from 'util';
import { ActivityTime } from '../activity-time';

export class ActivityTimeBuilder {
  static fromJson(json) {
    return (json)
      ? new ActivityTime(
        json.hash,
        json.name,
        json.running,
        json.warning,
        json.alarm,
        json.other,
        json.totalTime
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(ActivityTimeBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/activity-time.builder.ts